/**************************************************
 * Nombre:       RelojProcesando
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Typography} from "@mui/material";
import Countdown from "react-countdown";

const RelojMembresiaActiva = ({fecha}) => {

    const renderer = ({days, hours, minutes, seconds, completed}) => {

        return <span>{`${days} dias  ${hours}h-${minutes}m-${seconds}s`}</span>;

    };

    if (!fecha){
        return ''
    }

    return (
        <Typography sx={{
            fontSize: 18,
            fontWeight: 400,
            textAlign: 'center',
            lineHeight: 1.1
        }}>Hasta: <br/>
            <Countdown
                daysInHours={true}
                date={fecha}
                renderer={renderer}
            />
        </Typography>
    )

}
export default RelojMembresiaActiva